import { createEvent, restore, createStore, createEffect } from "effector";
import { getCustomUserAgent } from "../common/customUserAgent";
import { empty, isFail } from "./functions";
import { getUuidAndSession } from "./localStorage";
import { queryGetTransactions } from "../pages/payments/logics/getTransactions";
import axios from "axios";
import { toast } from "react-toastify";

export interface ITenant {
  accountId: number;
  dateFrom: string | null;
  dateUntil: string | null;
  id: number;
  name: string;
  registrationTypeId: any;
}
export interface IPay {
  accountId: number;
  amount: number;
  companyId: number;
  date: string | null;
  gate: string;
  id: number;
  payeename: string;
  paymentTypeId: number;
  pending: number;
  transactId: any;
}

export interface ITotalByMonth {
  accountId: number;
  billDate: string;
  id: number;
  monthAmount: number;
  pdfFileName: string;
  periodId: string;
  periodName: string;
}

export interface IAccountPoint {
  address: string;
  id: string;
  pointLatitude: number;
  pointLongitude: number;
}

export interface IAccount {
  externalAccountNum: string;
  address: string;
  balance: number;
  companyId: number;
  countPeople: number;
  err_code: number;
  execute_time: string;
  full: boolean;
  garbageCollectionPoints: IAccountPoint[],
  houseId: number;
  id: number;
  ownerFio: string;
  ownerTypeName: string;
  phone: string;
  tenants: ITenant[];
  pays: IPay[];
  totalByMonth: ITotalByMonth[];
  syncAccounts: IAccount[];
  masterUserId: number;
}

export interface IQueryAccountsResult {
  loaded: boolean;
  fail: boolean;
  failMsg: string;
  accounts: IAccount[];
}

export interface IDataObject {
  accParams:{
    account?: string | null;
    name?: string | null;
    secondName?: string | null;
    lastName?: string | null;
    inn?: string | null;
    kpp?: string | null;
    companyId?: string | null;
  }
  uuid?: string | null;
  session?: string | null;
}

export interface IQueryNewAccount {
  data: IDataObject;
  setNewAccount: React.Dispatch<React.SetStateAction<IAccount | null>>;
  setDisableWhileLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}
export interface IQueryUpdateAccount{
  account:IAccount
  accounts:IAccount[]
}

export const $accounts = createStore<IQueryAccountsResult>({
  loaded: false,
  fail: false,
  failMsg: "",
  accounts: [],
});

export const changeSelectedAccountIdx = createEvent<number>();

export const changeSelectedAccountId = createEvent<number>();

export const $selectedAccountIdx = restore<number>(changeSelectedAccountIdx, -1);
export const $selectedAccountId = restore<number>(changeSelectedAccountId, 0);

export const queryAccounts = createEffect<void, IQueryAccountsResult>();
export const updateAccount= createEffect<IQueryUpdateAccount, IQueryAccountsResult>();

export const AddChargesToAccount= createEffect<IQueryUpdateAccount, IQueryAccountsResult>();

export const AddOwnerTypeToAccount= createEffect<IQueryUpdateAccount, IQueryAccountsResult>();
export const queryAccountsChange = createEffect<
  IAccount[],
  IQueryAccountsResult
>();

export const queryAccountsAdd = createEffect<IAccount, IQueryAccountsResult>();
export const AccountsDoneLoading =createEvent()
export const queryAccountsDelete = createEffect<IAccount, any>();

$accounts.on(queryAccountsChange.doneData, (_, val) => val);
export const storeAccountsSet = createEffect<
  IQueryAccountsResult,
  IQueryAccountsResult
>();

$accounts.on(queryAccounts.doneData, (_, val) =>val);
$accounts.on(updateAccount.doneData, (_, val) => val);
$accounts.on(AddChargesToAccount.doneData, (_, val) => val);
$accounts.on(AddOwnerTypeToAccount.doneData, (_, val) => val);
$accounts.on(storeAccountsSet.doneData, (_, val) => val);
$accounts.on(AccountsDoneLoading, (accs) => {
  if(accs.accounts.length > 0) {
    changeSelectedAccountIdx(0)
    changeSelectedAccountId(accs.accounts[0].id)
  } else {
    changeSelectedAccountIdx(-1)
    changeSelectedAccountId(0)
  }
  //if($companies.getState().length == 0) queryCompanies()

})

$selectedAccountId.watch((accId) => {
  queryGetTransactions(accId+'')
})
AddChargesToAccount.use(async(acc)=>{  
  let newArray =acc.accounts.filter(e=>e.id!==acc.account.id)
  await axios.post("https://izba.kras-abs.ru/api/v3/charge/periods",{
      accountId:acc.account.id,
      ...getUuidAndSession()
    },
    {
      headers:{
        "Custom-User-Agent": getCustomUserAgent(),
      }
    }).then(res => {
      Object.assign(acc.account,{totalByMonth: res.data.chargePeriods});
    }).catch(res=>{
      console.log(res)
    })
    newArray.push(acc.account)
  let ret = {
    loaded: true,
    fail: false,
    failMsg: "Успешно",
    // accounts: accounts.filter((a, i) => a.err_code === 0),
    accounts: newArray
  } as IQueryAccountsResult;
  return ret 
})
AddOwnerTypeToAccount.use(async(acc)=>{  
  let newArray =acc.accounts.filter(e=>e.id!==acc.account.id)
  await axios.post("https://izba.kras-abs.ru/api/v3/account/otherInfo",{
      accountId:acc.account.id,
      ...getUuidAndSession()
    },
    {
      headers:{
        "Custom-User-Agent": getCustomUserAgent(),
      }
    }).then(res => {
      Object.assign(acc.account,{ownerTypeName: res.data.ownerTypeName});
    }).catch(res=>{
      console.log(res)
    })
    newArray.push(acc.account)
  let ret = {
    loaded: true,
    fail: false,
    failMsg: "Успешно",
    // accounts: accounts.filter((a, i) => a.err_code === 0),
    accounts: newArray
  } as IQueryAccountsResult;
  return ret 
})
updateAccount.use(async (acc)=>{
  let newArray =acc.accounts.filter(e=>e.id!==acc.account.id)
   await axios.post("https://izba.kras-abs.ru/api/v3/account/info",{
      accountId:acc.account.id,
      ...getUuidAndSession()
    },
    {
      headers:{
        "Custom-User-Agent": getCustomUserAgent(),
      }
    }).then(res => {
      let newAcc = res.data as IAccount
      Object.assign(acc.account,{address: newAcc.address});
      Object.assign(acc.account,{balance: newAcc.balance});
      Object.assign(acc.account,{companyId: newAcc.companyId});
    }).catch(res=>{
      console.log(res)
    })
    newArray.push(acc.account)
  let ret = {
    loaded: true,
    fail: false,
    failMsg: "Успешно",
    // accounts: accounts.filter((a, i) => a.err_code === 0),
    accounts: newArray
  } as IQueryAccountsResult;
  return ret 
})
queryAccountsChange.use((accs) => {
  return {
    loaded: true,
    fail: false,
    failMsg: "",
    accounts: [...accs],
  } as IQueryAccountsResult;
});

queryAccountsDelete.use((account) => {
  return fetch("https://izba.kras-abs.ru/api/v3/user/removeAccount", {
    method: "POST",
    body: JSON.stringify({
      accountId: account.id,
      ...getUuidAndSession(),
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  }).then((res) => res.json());
});

export const queryAccountsChangePass = (
  account: IAccount,
  oldPass: string,
  newPass: string
) => {
  return fetch("https://izba.kras-abs.ru/api/v3/account/setPasswordAbs", {
    method: "POST",
    body: JSON.stringify({
      accountId: account.id,
      oldPassword: oldPass,
      newPassword: newPass,
      ...getUuidAndSession(),
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  }).then((res) => res.json());
};

storeAccountsSet.use((accState) => accState);


queryAccounts.use(() =>
  fetch("https://izba.kras-abs.ru/api/v3/user/accounts", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    }, 
  })
    .then((res) => res.json())
    .then(async (res) => {
      if ( !("accounts" in res)) {
        let ret = {
          loaded: true,
          fail: false,
          failMsg: "Не удалось загрузить аккаунты",
          accounts: [],
        } as IQueryAccountsResult;
        return ret;
      }
      let accounts = res.accounts as IAccount[];
      
        let ret = {
        loaded: true,
        fail: false,
        failMsg: "Успешно",
        // accounts: accounts.filter((a, i) => a.err_code === 0),
        accounts: accounts
      } as IQueryAccountsResult;
      for( let i = 0, aLen= ret.accounts.length; i < aLen ; ++i) {
        if(!empty(ret.accounts[i].totalByMonth)) {
          ret.accounts[i].totalByMonth = ret.accounts[i].totalByMonth.sort((a, b) => a.periodId < b.periodId ? 1 : -1)
        }
      }
      /*let f = ret.accounts[0].garbageCollectionPoints[0]
      ret.accounts[0].garbageCollectionPoints = [f,f,f,f,f]*/
      return ret;
    })
    .catch((error) => {
      let ret = {
        loaded: true,
        fail: true,
        failMsg: error.message,
        accounts: [],
      } as IQueryAccountsResult;
      return ret;
    })
);

export const queryNewAccount = ({
  data,
  setNewAccount,
  setDisableWhileLoading,
  setIsValid,
}: IQueryNewAccount) => {
  const { uuid, session } = getUuidAndSession();
  data.uuid = uuid;
  data.session = session;
  // data.companyId="34";
  return fetch("https://izba.kras-abs.ru/api/v3/user/addAccount", {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      let { jsonData, fail, failMsg } = isFail(res, "addAccount");
      console.log(fail)
      if (!fail) return jsonData;
      throw new Error(failMsg);
    })
    // .then((res) => {
    //   setNewAccount(res.addAccount as IAccount);
    //   return res.addAccount;
    // });
};

export const getPaymentFile = (accountNum: string) => {
  const { uuid, session } = getUuidAndSession();
  return fetch("https://izba.kras-abs.ru/api/v2/getPaymentFile", { //не используется
    method: "POST",
    body: JSON.stringify({
      accountNum: accountNum,
      uuid: uuid,
      session: session,
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  })
    .then((res) => res.json())
};
